var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFavoritesShop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 40,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24Z",
    fill: "url(#paint0_linear_12012_163798)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0008 16.2996L15.9232 12.2087C16.6302 11.5023 16.8054 10.4225 16.3581 9.52877C16.0244 8.86163 15.3904 8.39554 14.6541 8.27608C13.9178 8.15662 13.1689 8.39835 12.6415 8.92577L12.0008 9.566L11.3602 8.92577C10.8327 8.39835 10.0839 8.15662 9.34756 8.27608C8.61126 8.39554 7.97726 8.86163 7.6436 9.52877C7.19688 10.4221 7.37188 11.5011 8.07805 12.2075L12.0008 16.2996Z",
    fill: "url(#paint1_linear_12012_163798)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12012_163798",
    x1: -7.15256e-7,
    y1: 8.51213e-7,
    x2: 25.888,
    y2: 21.7531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEF4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12012_163798",
    x1: 7.39849,
    y1: 8.24609,
    x2: 16.2103,
    y2: 16.7091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8647AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E64E9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1.0001,
    stopColor: "#2F1142"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoritesShop);
export default __webpack_public_path__ + "static/media/favoritesShop.4a68fb45e1f1c7acb7f4ea2f76bd1114.svg";
export { ForwardRef as ReactComponent };